import { useSelector } from 'react-redux';

import { CallAPI } from './utils.js';
import { clearAccessToken, setAccessToken } from './tokenStorage';
import { persistEmbedMode, isEmbeddedApp, clearEmbedMode } from '@/utils/embedMode';

const AUTH_REQUIRED_MESSAGE = 'ASK_BERNOULLI_AUTH_REQUIRED';

const login = async (username, password) => {
    let data = {
        username,
        password
    }
    try {
        const performLogin = await CallAPI(
            'user/login',
            'POST',
            {},
            data,
        );

        return performLogin;
    } catch (error) {
        throw error
    }

}

const register = async () => {
    try {

    } catch (error) {

    }
}

const logout = async () => {
    try {
        const performLogout = await CallAPI(
            'user/logout',
            'GET',
            {},
        );
        clearAccessToken();
        clearEmbedMode();
        return performLogout.message === 'success' ? true : false
    } catch (error) {
        clearAccessToken();
        clearEmbedMode();
        throw Error('Error while logout', error)
    }
}

const isLoggedIn = () => {
    const { user } = useSelector(state => state.userDetails);
    const { message } = user || {}
    if (message === 'success' && user != null) {
        return true
    } else {
        return false
    }
}

const loggedUserDetails = () => {
    const { user } = useSelector(state => state.userDetails);
    const { role, email, alt_username: username, message, id } = user || {}
    return { username, email, role, message, id }
}

const getLoginRedirectUrl = () => (
    process.env.NEXT_PUBLIC_NODE_ENV === 'development'
        ? `${process.env.NEXT_PUBLIC_LOCAL_MAIN_DOMAIN}/?refer=http://localhost:3001`
        : 'https://bernoullirisk.com/?refer=https://scorecard.bernoullirisk.com/'
);

const takeEmbedTokenFromUrl = () => {
    if (typeof window === 'undefined') return null;
    const embedded = persistEmbedMode();
    const url = new URL(window.location.href);
    const embedToken = url.searchParams.get('embed_token');
    if (embedded || embedToken) {
        url.searchParams.set('embed', '1');
    }
    if (embedToken) {
        url.searchParams.delete('embed_token');
    }
    if (embedToken || embedded) {
        const next = `${url.pathname}${url.search}${url.hash}`;
        window.history.replaceState({}, '', next || '/');
    }
    return embedToken;
}

const exchangeEmbedToken = async (embedToken) => {
    const result = await CallAPI(
        '/user/exchange-embed-token',
        'POST',
        {},
        { embed_token: embedToken },
    );
    if (result && result.access_token) {
        setAccessToken(result.access_token);
    }
    return result;
}

const notifyParentAuthRequired = () => {
    if (typeof window === 'undefined') return false;
    try {
        if (window.self === window.top) return false;
    } catch (e) {
        /* cross-origin frame */
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('embed_token');
    window.parent.postMessage(
        { type: AUTH_REQUIRED_MESSAGE, href: url.toString() },
        '*',
    );
    return true;
}

module.exports = {
    login,
    register,
    logout,
    isLoggedIn,
    loggedUserDetails,
    getLoginRedirectUrl,
    takeEmbedTokenFromUrl,
    exchangeEmbedToken,
    notifyParentAuthRequired,
    isEmbeddedApp,
}
